const SERVER_API = process.env.REACT_APP_SERVER_API;

const BANK_TYPE = `${SERVER_API}/services/bank_types`;
const CURRENCY_TYPE = `${SERVER_API}/services/currency_type`;
const SOCIAL_TYPE = `${SERVER_API}/services/social_type`;

const AGENT_LOGIN_API = `${SERVER_API}/login/operator`;
const AGENT_ACCESS_LIST_GET = `${SERVER_API}/agent/get_permission_list`;
const AGENT_ACCESS_LEVEL_CREATE = `${SERVER_API}/agent/create_permission`;
const AGENT_ACCESS_LEVEL_UPDATE = `${SERVER_API}/agent/permission_edit`;
const AGENT_ACCESS_LEVEL_DELETE = `${SERVER_API}/agent/permission_delete`;

const AGENT_EDIT_SELF = `${SERVER_API}/agent/edit_operator_self`;

const USER_GET_LIST = `${SERVER_API}/users/list`
const USER_CREATE = `${SERVER_API}/users/create`;
const USER_UPDATE = `${SERVER_API}/users/update_user`;
const USER_DELETE = `${SERVER_API}/users/delete`;

const OPERATOR_GET_LIST = `${SERVER_API}/agent/get_operator_list`;
const OPERATOR_CREATE = `${SERVER_API}/agent/create_operator`;
const OPERATOR_UPDATE = `${SERVER_API}/agent/edit_operator`
const OPERATOR_DELETE = `${SERVER_API}/agent/operator_delete`;


const OPERATOR_PASSWORD_RESET = `${SERVER_API}/agent/operator_password_reset`;
const OPERATOR_OWN_PASSWORD_RESET = `${SERVER_API}/agent/operator_own_password_reset`;
const OPERATOR_UNLOCK = `${SERVER_API}/agent/operator_unlock`;

const UPLOAD_API = `${SERVER_API}/agent/upload_image`;
const AVATAR_LIST = `${SERVER_API}/agent/get_avatar_list`;
const AVATAR_CREATE = `${SERVER_API}/agent/create_avatar`;
const AVATAR_DELETE = `${SERVER_API}/agent/avatar_delete`;

const AGENT_LIST = `${SERVER_API}/agent/agent_data`;
const AGENT_RECEIPT = `${SERVER_API}/transaction/agent_list_self`;

const AGENT_BANK_LIST = `${SERVER_API}/agent/get_bank_account_list`;
const AGENT_BANK_CREATE = `${SERVER_API}/agent/create_bank_account`;
const AGENT_BANK_DELETE = `${SERVER_API}/agent/bank_account_delete`;

const AGENT_BANK_ACTIVATE = `${SERVER_API}/agent/active_bank`;
const AGENT_BANK_DEACTIVATE = `${SERVER_API}/agent/deactive_bank`;

const AGENT_UPDATE_UI = `${SERVER_API}/agent/edit_ui`;

const USER_BANK_LIST = `${SERVER_API}/users/get_bank_accounts`;
const USER_BANK_CREATE = `${SERVER_API}/users/create_bank`;

const SOCKET_API = `${SERVER_API}`;


const USER_UNLOCK = `${SERVER_API}/users/unlock`;
const USER_PASSWORD_RESET = `${SERVER_API}/users/reset_password`;
const USER_DEPOSIT_CREATE = `${SERVER_API}/user-transaction/create_deposit`;


const USER_WITHDRAW_CREATE = `${SERVER_API}/user-transaction/create_withdraw`;
const USER_TRANSACTION_LIST = `${SERVER_API}/user-transaction/list`;


const AGENT_TRANSACTION_LIST = `${SERVER_API}/transaction/agent_single`;

const USER_UPDATE_DEPOSIT = `${SERVER_API}/user-transaction/update_deposit`;
const USER_UPDATE_WITHDRAW = `${SERVER_API}/user-transaction/update_withdraw`;


const SOCIAL_LIST = `${SERVER_API}/agent/get_social_list`;
const SOCIAL_CREATE = `${SERVER_API}/agent/create_social`;
const SOCIAL_UPDATE = `${SERVER_API}/agent/social_edit`;
const SOCIAL_DELETE = `${SERVER_API}/agent/social_delete`;

const GAME_LOG_API = `${SERVER_API}/users/game_logs`;

const GAME_LIST_PROVIDER = `${SERVER_API}/services/game_list_provider`;

const GAME_WALLET_TO_MAIN_WALLET = `${SERVER_API}/user-transaction/game_wallet_to_main_wallet`;

export {
  
  BANK_TYPE,
  CURRENCY_TYPE,
  SOCIAL_TYPE,

  AGENT_LOGIN_API,
  AGENT_ACCESS_LIST_GET,
  AGENT_ACCESS_LEVEL_UPDATE,
  AGENT_ACCESS_LEVEL_CREATE,
  AGENT_ACCESS_LEVEL_DELETE,

  AGENT_EDIT_SELF,

  USER_GET_LIST,
  USER_CREATE,
  USER_UPDATE,
  USER_DELETE,

  OPERATOR_GET_LIST,
  OPERATOR_CREATE,
  OPERATOR_UPDATE,
  OPERATOR_DELETE,

  OPERATOR_PASSWORD_RESET,
  OPERATOR_OWN_PASSWORD_RESET,
  OPERATOR_UNLOCK,

  UPLOAD_API,
  AVATAR_LIST,
  AVATAR_CREATE,
  AVATAR_DELETE,

  AGENT_BANK_LIST,
  AGENT_BANK_CREATE,
  AGENT_BANK_DELETE,

  AGENT_LIST,
  AGENT_UPDATE_UI,

  AGENT_RECEIPT,
  USER_BANK_LIST,
  USER_BANK_CREATE,

  AGENT_BANK_ACTIVATE,
  AGENT_BANK_DEACTIVATE,

  USER_UNLOCK,
  USER_PASSWORD_RESET,
  USER_DEPOSIT_CREATE,
  USER_WITHDRAW_CREATE,
  USER_TRANSACTION_LIST,

  SOCKET_API,

  USER_UPDATE_DEPOSIT,
  USER_UPDATE_WITHDRAW,

  AGENT_TRANSACTION_LIST,

  SOCIAL_LIST,
  SOCIAL_CREATE,
  SOCIAL_UPDATE,
  SOCIAL_DELETE,

  GAME_LOG_API,
  GAME_LIST_PROVIDER,
  GAME_WALLET_TO_MAIN_WALLET
};
